// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getCompany = createAsyncThunk('companySliceData/getCompany', async () => {
    try {
        let response = await axios.get('/Company', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCompanyoptions = createAsyncThunk('companySliceData/getCompanyoptions', async () => {
    try {
        let response = await axios.get('/Company?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCompanyById = createAsyncThunk('companySliceData/getCompanyById', async (id) => {
    try {
        let response = await axios.get('/Company/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCompanyStatus = createAsyncThunk('companySliceData/getCompanyStatus', async () => {
    try {
        let response = await axios.get('/Company?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteCompany = createAsyncThunk('companySliceData/deleteCompany', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Company/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Company deleted successfully.');
        await dispatch(getCompany());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createCompany = createAsyncThunk('companySliceData/createCompany', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Company', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Company added succesfully.');
        await dispatch(getCompany());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCompany = createAsyncThunk('companySliceData/updateCompany', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Company/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Company updated succesfully.');
        await dispatch(getCompany());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCompanyStatus = createAsyncThunk('companySliceData/updateCompanyStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/Company/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getCompany());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const companySlice = createSlice({
    name: 'companySliceData',
    initialState: {
        company: [],
        companyoption: [],
        companyData: [],
        dayAdjustment: [],
        companyStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getCompany.fulfilled, (state, action) => {
            state.company = action?.payload;
            return;
        });
        builder.addCase(getCompanyoptions.fulfilled, (state, action) => {
            state.companyoption = action?.payload;
            return;
        });
        builder.addCase(getCompanyById.fulfilled, (state, action) => {
            state.companyData = action?.payload;
            return;
        });
        builder.addCase(getCompanyStatus.fulfilled, (state, action) => {
            state.companyStatus = action?.payload;
            return;
        });
    }
});

export default companySlice.reducer;
